import script from "./ItemTextDivider.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemTextDivider.vue?vue&type=script&setup=true&lang=ts"

import "./ItemTextDivider.vue?vue&type=style&index=0&id=6fe7fc52&lang=scss"

const __exports__ = script;

export default __exports__